<template>
  <div>
    <p class="part-title">网络条件要求
    </p>
    <div class="part-content">
      <span class="content-title">说明客户端到服务器的带宽要求<span class="fangsong">（需提供测试带宽服务）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.net_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.net_claim_content"
        v-html="formInfo.net_claim_content"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">说明能够支持的同时在线人数<span class="fangsong">（需提供在线排队提示服务）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.net_claim_count"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.net_claim_count"
        v-html="formInfo.net_claim_count"
      ></div>
    </div>
    <p class="part-title">用户操作系统要求（如Windows、Unix、iOS、Android等）
    </p>
    <div class="part-content"><span class="content-title">计算机操作系统和版本要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.sys_claim_computer"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_computer"
        v-html="formInfo.sys_claim_computer"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算机终端操作系统和版本要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.sys_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_other"
        v-html="formInfo.sys_claim_other"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">支持移动端：</span>
      <div
        class="content-text"
        v-if="formInfo.sys_claim_mobile == 1"
      >是</div>
      <div
        class="content-text"
        v-else-if="formInfo.sys_claim_mobile == 0"
      >否</div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
    </div>
    <p class="part-title">用户非操作系统软件配置要求（兼容至少2种及以上主流浏览器）
    </p>
    <div class="part-content">
      <span class="content-title">（1）非操作系统软件要求（支持2种及以上主流浏览器）：</span>
      <div class="clearfix"></div>
      <div
        class="content-text"
        style="margin-right:10px"
        v-for="(item,index) in formInfo.not_sys_claim_soft"
        :key="index"
      >{{item}}</div>
      <div class="clearfix"></div>
      <span class="content-title">需要特定插件：</span>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin == 1"
      >是</div>
      <div
        class="content-text"
        v-else-if="formInfo.not_sys_claim_plugin == 0"
      >否</div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">插件名称：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_name"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_name"
        v-html="formInfo.not_sys_claim_plugin_name"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">插件容量：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_size"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_size"
        v-html="formInfo.not_sys_claim_plugin_size"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">下载链接：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_plugin_link"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_plugin_link"
        v-html="formInfo.not_sys_claim_plugin_link"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算机终端非操作系统软件配置要求<span class="fangsong">（需说明是否可提供相关软件下载）</span>：</span>
      <div
        class="content-text"
        v-if="!formInfo.not_sys_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.not_sys_claim_content"
        v-html="formInfo.not_sys_claim_content"
      ></div>
    </div>
    <p class="part-title">用户硬件配置要求（如主频、内存、显存、存储容量等）
    </p>
    <div class="part-content"><span class="content-title">计算机硬件配置要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_hardware_claim_computer"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_hardware_claim_computer"
        v-html="formInfo.user_hardware_claim_computer"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算终端硬件配置要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_hardware_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_hardware_claim_other"
        v-html="formInfo.user_hardware_claim_other"
      ></div>
    </div>
    <p class="part-title">用户特殊外置硬件要求（如可穿戴设备等）
    </p>
    <div class="part-content"><span class="content-title">计算机特殊外置硬件要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.user_special_claim_hardware"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_special_claim_hardware"
        v-html="formInfo.user_special_claim_hardware"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">其他计算终端特殊外置硬件要求：{{formInfo.user_special_claim_other?'有':'无'}}</span>
      <div class="clearfix"></div>
      <p class="fangsong">（如勾选“有”，请填写其他计算终端特殊外置硬件要求）</p>
      <div
        class="content-text"
        v-if="!formInfo.user_special_claim_other"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.user_special_claim_other"
        v-html="formInfo.user_special_claim_other"
      ></div>
    </div>
    <p class="part-title">网络安全（实验系统要求完成国家信息安全等级二级认证）
    </p>
    <div class="part-content"><span class="content-title">证书编号：</span>
      <div class="content-text">{{formInfo.net_safe_claim.report_num?formInfo.net_safe_claim.report_num:'暂无内容'}}
      </div>
      <div class="clearfix"></div><span class="content-title">请附信息系统安全等级保护备案证明：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(1,formInfo.net_safe_claim.record_name)"
      >{{formInfo.net_safe_claim.record_name?formInfo.net_safe_claim.record_name:'暂无内容'}}</div>
      <div class="clearfix"></div><span class="content-title">其他证明材料（定级报告或测评报告中申报实验系统的相关描述页面)：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(2,formInfo.net_safe_claim.des_name)"
      >{{formInfo.net_safe_claim.des_name?formInfo.net_safe_claim.des_name:'暂无内容'}}</div>
    </div>

    <div
      id="res-preview-overlay"
      :style="formatShowWindow(showWindow.preview)"
    >
      <div id="res-preview-overlay-bg"></div>
      <div id="res-preview-panel">
        <div id="res-preview-title">{{previewInfo.title_name}}
          <div
            id="res-preview-close"
            @click="showWindow.preview = false"
          >x</div>
        </div>
        <div id="res-preview-content">
          <div
            class="pdf-region"
            v-if="previewInfo.previewType"
          >
            <pdf
              :page="pageNum"
              :src="previewInfo.previewPath"
              @progress="loadedRatio = $event"
              @num-pages="pageTotalNum=$event"
            ></pdf>
            <div class="pagecolor">
              <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
            </div>
          </div>

          <div
            class="img-region"
            v-else
          >
            <img
              :src="previewInfo.previewPath"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: 'NetRequire',
  components: {
    pdf
  },
  props: ['expId'],
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      showWindow: {
        net: false,
        sys: false,
        not_sys: false,
        hard: false,
        spec: false,
        net_safe: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        },
        preview: false
      },
      previewInfo: {
        previewType: '',
        title_name: '',
        previewPath: '',
        excelData: null
      },
      formInfo: {
        net_claim_content: '',
        net_multi_computer: false,
        net_claim_count: '',

        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: '',

        not_sys_claim_soft: [],
        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: '',

        user_hardware_claim_computer: '',
        user_hardware_claim_other: '',

        user_special_claim_hardware: '',
        user_special_claim_other: '',

        net_safe_claim: ''
      },
      formNet: {
        net_claim_content: '',
        net_multi_computer: false,
        net_claim_count: ''
      },
      formSys: {
        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: ''
      },
      formNotSys: {
        not_sys_claim_soft: [],
        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: ''
      },
      formHard: {
        user_hardware_claim_computer: '',
        user_hardware_claim_other: ''
      },
      formSpec: {
        user_special_claim_hardware: '',
        user_special_claim_has_other: '',
        user_special_claim_other: ''
      },
      formNetSafe: {
        report_num: '',
        record_path: '',
        record_name: '',
        des_path: '',
        des_name: ''
      },
      toggleUpload: 1,
      sensitiveWord: []
    }
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    getPreviewInfo(num, val) {
      var arr
      if (val) {
        arr = val.slice(-3, val.length)
        this.previewInfo.previewType = arr === 'pdf'
        this.showWindow.preview = true
      }

      if (num === 1) {
        if (this.formInfo.net_safe_claim.record_name) {
          this.previewInfo.title_name = this.formInfo.net_safe_claim.record_name
          this.previewInfo.previewPath = this.formInfo.net_safe_claim.record_path
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      } else {
        if (this.formInfo.net_safe_claim.des_name) {
          this.previewInfo.title_name = this.formInfo.net_safe_claim.des_name
          this.previewInfo.previewPath = this.formInfo.net_safe_claim.des_path
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.not_sys_claim_soft = data.not_sys_claim_soft ? JSON.parse(data.not_sys_claim_soft) : ''
        this.formInfo.net_safe_claim = data.net_safe_claim ? JSON.parse(data.net_safe_claim) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    /**
     * 根据字段打开/关闭相应的弹窗
     */
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {
          visibility: 'hidden'
        }
      }
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-infor-2020.css"></style>

<style lang="less" scoped>
</style>
